import CoreBase from '../../../../../services/engines/CoreBase';
import userTopicService from '../../../../../services/UserTopicService';
import responseHelper from '../../../../../services/ResponseHelper';

class UpdateBodyHandler extends CoreBase {
    _name = 'UpdateBodyHandler';

    /**
     * Handles jerny:updatebody — merges fields into data note body and persists.
     * Gebruikt voor inline edit van title, subtitle en andere root velden in data note JSON.
     * @param {MessageEvent} e
     * @param {HTMLIFrameElement} iframe
     * @param {object} entry
     */
    handle = async (e, iframe, entry) => {
        try {
            if (e.source !== iframe?.contentWindow) return;

            const fields = e.data?.fields;
            if (!fields || !entry?.body) return;

            let body;
            try {
                body = JSON.parse(entry.body);
            } catch (_) {
                this.logError('handle', 'entry body is not valid JSON');
                return;
            }

            // merge gewijzigde velden in body
            Object.assign(body, fields);

            const serialized = JSON.stringify(body);
            const resp = await userTopicService.updateJournalBody(entry.rk, serialized);
            if (responseHelper.check(resp, 'handle', this._name) < 0) return;

            // entry body in memory updaten zodat rebuild de nieuwe waarden heeft
            entry.body = serialized;
        } catch (error) {
            this.logError('handle', error.message);
        }
    };
}

const updateBodyHandler = new UpdateBodyHandler();
export default updateBodyHandler;
